cv.TableRowEmptyView = Marionette.ItemView.extend({
  tagName : 'tr',
  className : 'no-results',

  template : cv.Templates['table/row_empty'],

  events : {
  },

  initialize: function(options){
    this.mergeOptions(options, this.options);

    console.log('TableRowEmptyView initialized');
  },

  templateHelpers: function(){
    return {
      image : this.options.row_empty_data.image,
      message : this.options.row_empty_data.message
    }
  },

  onShow: function(){
  }
});
